
export class DisplayCategory {
  categoryID: number;
  categoryName: string;
  isParent: boolean;
  parentCategoryID: number;
  productCount: number;
  tinyImage: string;
  isChecked: boolean;
  subCategory: DisplayCategory[];
}




// WEBPACK FOOTER //
// ./src/app/models/category/DisplayCategory.model.ts